import { useState } from "react";
import { EyeIcon } from "../assests/svg/SvgIcons";
import {
  forgot_Password,
  log_in_by_email,
  enable_user_account,
} from "../api/serverWrapper";
import UserSystemRole from "../components/UserSystemRole";
import { saveData } from "../utils/store-data";
import {
  AGENT_LOGIN,
  CLIENT_LOGIN,
  CLIENT_PROFILE_CODE,
  LOGIN_BY,
  PROFILE_LOGIN,
  USER_EMAIL,
  USER_ID,
} from "../utils/store-data-constants";
import { useNavigate } from "react-router-dom";
import { loginByEmail } from "../utils/Constants";

const EmailLogin = ({ setEmailMode, loginType }) => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});

  const [accountDeletedPopup, setAccountDeletedPopup] = useState(false);
  const [accountDisabledPopup, setAccountDisabledPopup] = useState(false);
  const [disabledUserId, setDisabledUserId] = useState(null);
  const [isEnabling, setIsEnabling] = useState(false);

  const [showForgot, setShowForgot] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [resetLoading, setResetLoading] = useState(false);
  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const navigate = useNavigate();
  const login = async () => {
    if (loading) return;
    let newErrors = {};

    if (!email.trim()) {
      newErrors.email = "Email is required";
    } else if (!isValidEmail(email)) {
      newErrors.email = "Enter valid email address";
    }

    if (!password.trim()) {
      newErrors.password = "Password is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    let data = {
      EMail: email,
      Password: password,
    };
    setLoading(true);
    try {
      let resp = await log_in_by_email(data);
      console.log(resp);

      if (resp.success) {
        // Deleted Account
        if (resp.data.IsDeleted) {
          setAccountDeletedPopup(true);
          return;
        }

        // Disabled Account
        if (!resp.data.IsActive) {
          setDisabledUserId(resp.data.UserId);
          setAccountDisabledPopup(true);
          return;
        }

        await saveData(USER_ID, resp.data.UserId);

        if (
          resp.data.SystemRole === UserSystemRole.AGENT.id &&
          loginType === "Agent"
        ) {
          console.log(resp.data);

          if (resp.data.IsTempRegistered) {
            await saveData(LOGIN_BY, loginByEmail);
            await saveData(USER_EMAIL, email);
            navigate("/business_setup");
          } else {
            await saveData(AGENT_LOGIN, true);
            await saveData(PROFILE_LOGIN, false);
            await saveData(CLIENT_LOGIN, false);
            navigate("/dashboard", { replace: true });
          }
        } else if (
          resp.data.SystemRole === UserSystemRole.CLIENT.id &&
          loginType === "Client"
        ) {
          if (resp.data.IsTempRegistered) {
            await saveData(LOGIN_BY, loginByEmail);
            await saveData(USER_EMAIL, email);
            navigate("/client_setup");
          } else {
            await saveData(AGENT_LOGIN, false);
            await saveData(PROFILE_LOGIN, false);
            await saveData(CLIENT_LOGIN, true);
            navigate("/dashboard");
          }
        } else if (Number(resp.data.SystemRole) === UserSystemRole.PROFILE.id) {
          if (resp?.data?.profile?.IsProfileActivated) {
            await saveData(USER_ID, resp.data.UserId);
            await saveData(AGENT_LOGIN, false);
            await saveData(CLIENT_LOGIN, false);
            await saveData(PROFILE_LOGIN, true);
            await saveData(CLIENT_PROFILE_CODE, resp.data.profile.ClientCode);
            navigate("/profileforclient", {
              state: { client: resp.data.profile },
            });
          } else {
            navigate("/profilelogin");
          }
        } else {
          alert("Invalid Email Try Again");
          navigate("/home");
        }
      } else {
        alert(resp.message || "Login failed");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleReactivateAccount = async () => {
    try {
      setIsEnabling(true);
      const resp = await enable_user_account({ UserId: disabledUserId });
      console.log(resp);

      if (resp?.code === 200) {
        setAccountDisabledPopup(false);
        setTimeout(() => {
          navigate("/home");
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsEnabling(false);
    }
  };

  const handleResetPassword = async () => {
    if (!resetEmail) {
      alert("Enter email");
      return;
    }

    setResetLoading(true);
    try {
      let res = await forgot_Password({ EMail: resetEmail });

      if (res.success) {
        alert("New password sent to your email");
        setShowForgot(false);
        setResetEmail("");
      } else {
        alert(res.message || "Something went wrong");
      }
    } catch (err) {
      console.log(err);
      alert("Error sending reset email");
    } finally {
      setResetLoading(false);
    }
  };

  return (
    <div className="email-card">
      <h2>Email Login</h2>

      <form
        onSubmit={(e) => {
          e.preventDefault(); // prevent page reload
          login();
        }}
      >
        <div className="email-field">
          <label>Email ID</label>
          <input
            type="email"
            placeholder="Email ID"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        {errors.email && <span className="error-text">{errors.email}</span>}

        <div className="email-field password-wrapper">
          <label>Password</label>

          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          {/* 👁 Eye Icon */}
          <span
            className="eye-icon"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? "🙈" : EyeIcon}
          </span>
        </div>
        {errors.password && (
          <span className="error-text">{errors.password}</span>
        )}
        <div className="d-flex justify-content-between">
          {/* <span className="error-text">Wrong Password</span> */}
          <span
            className="error-text"
            style={{ cursor: "pointer" }}
            onClick={() => setShowForgot(true)}
          >
            Forgot Password?
          </span>
        </div>

        <button className="email-submit mt-4" type="submit">
          {loading ? <span className="spinner"></span> : <> Login →</>}
        </button>
      </form>

      <div className="email-switch">
        Not registered with us?{" "}
        <span onClick={() => setEmailMode("signup")}>Signup →</span>
      </div>

      {/* <div className="email-back" onClick={() => setEmailMode(null)}>
        ← Back
      </div> */}

      {showForgot && (
        <div className="forgot-popup">
          <div className="forgot-card">
            <h3>Reset Password</h3>

            <input
              type="email"
              placeholder="Enter your email"
              value={resetEmail}
              onChange={(e) => setResetEmail(e.target.value)}
            />

            <div className="forgot-actions">
              <button
                className="cancel-btn"
                onClick={() => setShowForgot(false)}
              >
                Cancel
              </button>

              <button
                className="confirm-btn"
                onClick={handleResetPassword}
                disabled={resetLoading}
              >
                {resetLoading ? "Sending..." : "Confirm"}
              </button>
            </div>
          </div>
        </div>
      )}

      {accountDeletedPopup && (
        <div className="modal-overlay">
          <div className="confirm-modal">
            <h2>Account Deleted</h2>
            <p>
              Your account has been permanently deleted. Please contact support
              if you believe this is a mistake.
            </p>
            <div className="modal-actions">
              <button
                className="confirm-btn"
                onClick={() => {
                  setAccountDeletedPopup(false);
                  navigate("/home");
                }}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {accountDisabledPopup && (
        <div className="modal-overlay">
          <div className="confirm-modal">
            <h2>Account Disabled</h2>
            <p>
              Your account is currently disabled. Would you like to reactivate
              your account?
            </p>
            <div className="modal-actions">
              <button
                className="confirm-btn"
                onClick={handleReactivateAccount}
                disabled={isEnabling}
                style={{
                  opacity: isEnabling ? 0.7 : 1,
                  cursor: isEnabling ? "not-allowed" : "pointer",
                }}
              >
                {isEnabling ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                    }}
                  >
                    <span className="spinner"></span>
                    Enabling...
                  </div>
                ) : (
                  "Enable Account"
                )}
              </button>
              <button
                className="cancel-btn"
                onClick={() => {
                  setAccountDisabledPopup(false);
                  navigate("/home");
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmailLogin;
